import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectTypeFilter = createSelector(
  [(store: RootState) => store.documentsSignerList.typeFilter],
  (value) => value
);
